<template>
    <div class="updatePicture">
        <b-form @submit="onSubmit">
            <b-row>
                <b-col cols="1"></b-col>
                <b-col >
                    <b-img :src="picture.url" height="500" width="750" fluid alt="Noch kein Bild vorhanden"></b-img>
                </b-col>
                <b-col >
                    <b-form-group   id="categoryInputGroup"
                                    horizontal
                                    :label-cols="3"
                                    label="Kategorie: *"            
                                    label-for="categoryInput">
                        <b-form-select id="categoryInput"
                                       v-model="picture.category_name"
                                       :options="categories"
                                       required>

                        </b-form-select>
                    </b-form-group> 
                    <b-form-group   id="titleInputGroup"
                                    horizontal
                                    :label-cols="3"
                                    label="Bildtitle:"            
                                    label-for="titleInput">
                        <b-form-input   id="titleInput"
                                        type="text" 
                                        v-model="picture.title"
                                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group  id="DescriptionInputGroup"
                                   horizontal
                                   :label-cols="3"
                                   label="Beschreibung: *"            
                                   label-for="descriptionInput">
                        <b-form-textarea    id="titleInput"
                                            v-model="picture.description"
                                            :rows="2"
                                            :max-rows="4"
                                            required>
                        </b-form-textarea>
                    </b-form-group>
                    <b-form-group label="Bild auf der Startseite anzeigen? *"

                                  horizontal
                                  :label-cols="4"
                                  >

                                  <b-form-radio-group id="btnradios2"
                                                      buttons
                                                      button-variant="outline-primary"
                                                      size="lg"
                                                      v-model="picture.front_page"
                                                      :options="boolean_options_fp"
                                                      name="radioBtnOutline" >
                                  </b-form-radio-group>
                    </b-form-group>	
                        <b-form-group label="Bild anzeigen? *"

                                      horizontal
                                      :label-cols="4"
                                      >
                                      <b-form-radio-group id="btnradios3"
                                                          buttons
                                                          button-variant="outline-primary"
                                                          size="lg"
                                                          v-model="picture.active"
                                                          :options="boolean_options"
                                                          name="radioBtnOutline" >
                                      </b-form-radio-group>  

                        </b-form-group>	
                            <b-button type="submit" variant="primary">speichern</b-button>
                            </br>* Felder müssen ausgefüllt werden.
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>

        </b-form>
    </div>
</template>

<script>
import {HTTP} from './http-common';
import AmplifyStore from '../store/store';

export default {
    name: 'updatePicture',
    data () {
        return {
            picture: {
            },
            selected: 1,
            categories: [],
            boolean_options: [
                { text: 'Ja', value: 't' },
                { text: 'Nein', value: 'f' }
            ],
            boolean_options_fp: [
                { text: 'Ja', value: 'front-page' },
                { text: 'Nein', value: 'no' }
            ]
        }
    },
    methods: {
        getPicture(uuid) {
            HTTP.get(
                `picture/${uuid}`, 
                {headers: {Authorization: `Bearer ${AmplifyStore.state.user.signInUserSession.idToken.jwtToken}`}})
                .then(response => {
                    this.picture = response.data[0];
                });
        },
        getCategories() {
            HTTP.get(`categories`)
                .then(response => {
                    this.categories = response.data;
                    var i;
                    for (i = 0; i < this.categories.length; i++){
                        this.categories[i].value = this.categories[i];
                        this.categories[i].text = this.categories[i].name;
                    }
                });
        },
        onSubmit(e){
            e.preventDefault(); 

            let updatedPicture = {
                uuid: this.picture.uuid,
                category_name: this.picture.category_name.name,
                category_type_name: this.picture.category_name.type_name,
                title: this.picture.title,
                description: this.picture.description,
                url: this.picture.url,
                front_page: this.picture.front_page,
                active: this.picture.active,
                order: this.picture.order
            }

            HTTP.put(
                `picture/${this.$route.params.uuid}`, 
                JSON.stringify(updatedPicture),
                {headers: {Authorization: `Bearer ${AmplifyStore.state.user.signInUserSession.idToken.jwtToken}`}}
            ).then(response => {
                    this.$router.push({ name: 'Home' })
            });
        }
    },
    created: function(){
        this.getPicture(this.$route.params.uuid)
        this.getCategories()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form {
    margin-top: 2em;
}
</style>




// WEBPACK FOOTER //
// src/components/UpdatePicturePage.vue